// extracted by mini-css-extract-plugin
module.exports = {"varSpUp2":"1.5rem","container":"container--d3cdc","hide":"hide--a2191"};